<template>
  <div class="m-card-pay">
    <van-dialog
      v-model="dialogModel"
      show-cancel-button
      :confirmButtonText="$t('confirm.msg_fail_confirm')"
      :cancelButtonText="$t('confirm.msg_fail_cancel')"
      :before-close="onPayment"
    >
      <div class="pay-popup" v-if="payType == 'Mobile'">
        <div class="pay-popup-number">
          <div class="area" @click="isAreaView = true">
            <span>+{{ payInfo.areaCode }}</span>
            <div class="area-down"></div>
          </div>
          <van-field
            type="number"
            v-model="payInfo.phone"
            class="pay-popup-phone"
            :placeholder="$t('login.phone_number')"
          />
        </div>
      </div>
      <van-row v-else class="card-pay-dialog">
        <van-field
          type="number"
          maxlength="24"
          placeholder="card number"
          class="card-pay-dialog-card"
          v-model="payInfo.cardNumber"
        />
        <van-col span="13">
          <van-col span="11">
            <van-field
              type="number"
              maxlength="2"
              placeholder="MM"
              v-model="payInfo.expiryMonth"
          /></van-col>
          <van-col span="1"></van-col>
          <van-col span="11">
            <van-field
              type="number"
              maxlength="2"
              placeholder="YY"
              v-model="payInfo.expiryYear"
          /></van-col>
        </van-col>
        <van-col span="1"></van-col>
        <van-col span="10">
          <van-field
            type="number"
            maxlength="3"
            placeholder="CVV"
            v-model="payInfo.cvv"
          />
        </van-col>
      </van-row>
    </van-dialog>
    <select-area v-model="isAreaView" @select="onSelct"></select-area>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SelectArea } from "@/components/select";
export default {
  name: "SaveCardPay",
  props: {
    payMode: {},
    payType: {},
    dialogPopup: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SelectArea
  },
  watch: {
    dialogPopup(val) {
      this.dialogModel = val;
    }
  },
  computed: {
    ...mapState(["system", "user"]),
    i18n() {
      return this.$t("confirm");
    }
  },
  data() {
    return {
      dialogModel: false,
      isAreaView: false,
      payInfo: {
        show: false,
        phone: "", // "",
        email: "",
        areaCode: "86",
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: ""
      }
    };
  },
  methods: {
    onSelct(val) {
      this.payInfo.areaCode = val;
    },
    // 手机号码
    MobilePay(done) {
      const fieldValues = { ...this.payInfo };
      if (!fieldValues.phone) {
        this.$toast(this.$t("msg.msg_none_mobile"));
        return done(false);
      }
      this.payInfo = { ...fieldValues, phone: "" };
      this.$emit("onPayment", { show: false, ...fieldValues });
      done();
    },
    // SaveCardPay 支付
    SaveCardPay(done) {
      const fieldValues = { ...this.payInfo };
      if (!fieldValues.cardNumber) {
        this.$toast(`请输入 cardNumber`);
      } else if (!fieldValues.expiryMonth) {
        this.$toast(`请输入 expiryMonth`);
      } else if (!fieldValues.expiryYear) {
        this.$toast(`请输入 expiryYear`);
      } else if (!fieldValues.cvv) {
        this.$toast(`请输入 cvv`);
      } else {
        this.payInfo = {
          ...fieldValues,
          cvv: "",
          cardNumber: "",
          expiryMonth: "",
          expiryYear: ""
        };
        fieldValues.cardNumber = fieldValues.cardNumber.replace(/\s/g, "");
        this.$emit("onPayment", { show: false, ...fieldValues });
        return done();
      }
      return done(false);
    },
    // 确认支付
    onPayment(action, done) {
      if (action === "confirm") {
        if (this.payType === "Mobile") {
          this.MobilePay(done);
        } else {
          this.SaveCardPay(done);
        }
      } else if (action === "cancel") {
        this.$emit("onPayment", { show: false, cancel: true });
        done();
      }
    }
  },
  created() {
    if (this.user && this.user.email) {
      this.payInfo.email = this.user.email;
    }
  }
};
</script>

<style lang="less" scoped>
.pay-popup {
  margin: 64px 0 32px;
  padding: 24px 46px;
  &-number {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    padding-left: 24px;
    border-radius: 16px;
    border: 1px solid #ccc;
    overflow: hidden;
  }
  &-phone {
    font-size: 32px;
  }
}
.card-pay-dialog {
  width: 90%;
  margin: 64px auto 42px;
  .van-cell {
    border: 1px solid #ebedf0;
    border-radius: 12px;
  }
  &-card {
    margin: 28px 0;
  }
}
</style>
